import { render, staticRenderFns } from "./FreeTextBroadcast.vue?vue&type=template&id=ec56c674"
import script from "./FreeTextBroadcast.vue?vue&type=script&lang=js"
export * from "./FreeTextBroadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports